import { call, put } from 'redux-saga/effects';
import { ContractAsyncActions } from 'store/actions/contract';
import { apiCall } from 'utils/apiCall';
import { toast } from 'react-toastify';

function* update(action) {
  const {
    SaveListingContract: {
      Actions: { SUCCESS, FAILURE },
    },
  } = ContractAsyncActions;
  const {
    payload: { contract, state },
  } = action;

  try {
    yield call(apiCall, `/listings/${contract.listingId}/contract`, 'put', contract);
    const response = yield call(apiCall, `/listings/${contract.listingId}/contract/state/${state}`, 'put');
    yield put(SUCCESS(response.data));
  } catch (error) {
    toast.error(error.message);
    yield put(FAILURE(error));
  }
}

export default update;
